import { BaseFinalCommand } from "./BaseFinalCommand";

export class ConfigGetItemCommand extends BaseFinalCommand
{
    private key: string;
    constructor(argv: string[], key: string)
    {
        super(argv, [], []);
        this.key = key;
    }
    override async exec()
    {
        let value = this.app.storage.getItem(`config.${this.key}`);
        let object: { [key: string]: string } = {};
        object[this.key] = value;
        this.app.logger.success(JSON.stringify(object));
    }
}